import * as _ from "lodash";
import * as angular from "angular";
import { Issue } from "../../../models/issue.model";
import { DialogUtils } from "../../../helper/dialog.helper";
import { issuePermissionIds } from "../../../utils/user-permissions";

let IssueAssignComponent = {
    selector: "vcIssueAssign",
    templateUrl: "/angular/components/issue/modals/issue-assign.component.html",
    bindings: {
        selectedIssue: "=",
    },
    controller: class IssueAssignController {
        // * bindings for typescript compiler *
        public selectedIssue: any;
        // ************************************

        private dialog: DialogUtils;
        public issue: Issue;
        public statuses: object;
        public issuePermissions = issuePermissionIds();

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.issue = _.cloneDeep(this.selectedIssue);
        }

        confirm(): void {
            this.dialog.hide(this.issue);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("issue")
    .component(IssueAssignComponent.selector, IssueAssignComponent);
